import { CommonModule } from "@angular/common";
import { Component, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Measurement, MeasurementStateService } from "@evident/ngx-media-viewer";
import { TranslateModule } from "@ngx-translate/core";
import { ConvertMeasure } from "../convert-measure.pipe";
import * as Measure from "../measurement.type";
import { ButtonComponent } from "@evc/web-components";
import { MeasurementService } from "../services/measurement.service";

@Component({
  selector: "app-measurement-results",
  imports: [TranslateModule, CommonModule, ConvertMeasure, ButtonComponent],
  templateUrl: "./measurement-results.component.html",
  styleUrl: "./measurement-results.component.scss",
  standalone: true
})
export class MeasurementResultsComponent {
  public measurements: Signal<Measurement[]>;
  /** Held by the measurement service: the save stores the unit the results are listed in, for the reports. */
  public unitSystem: Signal<Measure.UnitSystem>;
  public selectedMeasurement$: Signal<Measurement | undefined>;
  public selectedPointId: Signal<string | undefined>;

  constructor(
    private measurementState: MeasurementStateService,
    private measurementService: MeasurementService
  ) {
    this.measurements = toSignal(this.measurementState.measurements$, { initialValue: [] });
    this.unitSystem = this.measurementService.unitSystem.asReadonly();
    this.selectedMeasurement$ = toSignal(this.measurementState.selectedMeasurement$);
    this.selectedPointId = toSignal(this.measurementState.selectedPointId$);
  }

  public get precision() {
    return Measure.precision(this.unitSystem());
  }

  public getUnitLabel(unit: Measure.UnitType): string {
    return Measure.getUnitLabel(unit, this.unitSystem());
  }

  public getResults(measurement: Measurement): Measure.MeasurementResultItem[] {
    return Measure.getMeasurementResults(measurement);
  }

  public changeUnitSystem() {
    this.measurementService.toggleUnitSystem();
  }

  public getChangeUnitLabel() {
    return Measure.isMetric(this.unitSystem()) ? "Imperial" : "Metric";
  }

  public removeMeasure(measurement: Measurement) {
    this.measurementState.deleteMeasurement(measurement);
  }

  public selectMeasurement(measurement: Measurement) {
    this.measurementState.setSelectedMeasurement(measurement);
  }
}
